import Row from './src/row';

/* istanbul ignore next */
Row.install = function(Vue) {
  Vue.component(Row.name, Row);
};

export default Row;




// WEBPACK FOOTER //
// ./packages/row/index.js